import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useProjectAccess } from '@/hooks'
import { SHARE_PERMISSION } from '@/permissions/project/definitions'
import { Invite } from './components/Invite'
import { Member } from './components/Member'
import { Team } from './components/Team'
import css from './Members.module.scss'

const Members: React.FC = () => {
  const members = useSelector(migrationProjectSelector.getProjectMembers)
  const team = useSelector(migrationProjectSelector.getProjectTeam)

  const { hasAccess: hasAccessToInvite } = useProjectAccess(
    SHARE_PERMISSION.MANAGE_PROJECT_MEMBERS
  )

  const isReport = useSelector(migrationProjectSelector.getProjectIsReport)

  return (
    <div className={css.container}>
      <div className={css.title}>
        {isReport ? 'Members' : 'Users with access'}
      </div>

      <div className={css.members}>
        {team && <Team team={team} canEdit={isReport} />}

        {members.map((member) => (
          <Member member={member} key={member.id} />
        ))}
      </div>

      {hasAccessToInvite && <Invite />}
    </div>
  )
}

export default Members
